module.exports = __webpack_public_path__ + "img/dosing-guide.ca73bde4.png";